export const hiddenAnchorStyle = {
    color: 'inherit',
    textDecoration: 'none'
};

export const optionListItemStyle = {
  listStyle: 'none',
  lineHeight: 2,
  marginTop: 10
}

export const pretendAnchorStyle = {
  color: '#3cb7e3',
  textDecoration: 'none'
}


// WEBPACK FOOTER //
// ./src/Components/checkout/components/styles.js